define(function(require,exports,module) {
    var tpl =   '<% for(i=0; i<data.length; i++) {%>'+
                '<li class="li-item" skuid="J_<%=data[i].skuText%>" clstag="firsttype|keycount|jdworldwideself|ssdz<%=i+1%>">'+
                    '<a href="<%=data[i].skuUrl%>" target="_blank">'+
                        '<% if(data[i].skuIconList) { %>'+
                        '<img src="<%=data[i].skuIconList%>" class="logo">'+
                        '<% } %>'+
                        '<img src="<%=data[i].skuImg%>" class="item-img">'+
                    '</a>'+
                    '<a href="<%=data[i].skuUrl%>" target="_blank" class="info">'+
                        '<% if(data[i].countryList) { %>'+
                        '<img src="<%=data[i].countryList.imgUrl%>" class="icon-state"><%=data[i].itemText%>'+
                        '<% } %>'+
                    '</a>'+
                    '<div class="price">'+
                        '<span></span>'+
                        '<div class="consult"></div>'+
                    '</div>'+
                    '<a href="//cart.jd.hk/gate.action?pid=<%=data[i].skuText%>&pcount=1&ptype=1" class="btnBuy">BUY</a>'+
                '</li>'+
                '<% } %>';
    exports.tpl = tpl;
});


// WEBPACK FOOTER //
// ./src/js/template/selfChangeItem.js